import { Spacer, Textarea, Trg16 } from "oui";
import { useEffect, useState } from "react";
import { ISurveyOptionAnswer, ISurveyQuestion, ISurveyQuestionOption } from "../../../infra/api/SurveyApi";
import useToast from "../../../application/hooks/useToast";
import * as S from "./Survey.styled";
import OptionButton, { ISurveyOptionInput } from "./SurveyQuestionOption";

export interface SurveyQuestionProps {
    index: number,
    question: ISurveyQuestion,
    onChangeAnswers: (question: ISurveyQuestion, answers: ISurveyOptionAnswer[]) => void,
    onChangeText: (question: ISurveyQuestion, option: ISurveyQuestionOption | null, text: string) => void,
}


const SurveyQuestion = ({
    index,
    question,
    onChangeAnswers,
    onChangeText,
}: SurveyQuestionProps) => {
    const [text, setText] = useState("");
    const [options, setOptions] = useState<ISurveyOptionInput[]>([]);
    const [answers, setAnswers] = useState<ISurveyOptionAnswer[]>([]);
    const { addToast } = useToast();

    useEffect(() => {
        if (question.options) {
            setOptions(question.options.map(option => {
                return {
                    ...option,
                    selected: false,
                }
            }));
        }
    }, [question]);

    const onChangeOptionText = (option: ISurveyQuestionOption, text: string) => {
        if (onChangeText) {
            onChangeText(question, option, text);
        }
    };

    const onChange = (e: any) => {
        setText(e.target.value);
        onChangeText(question, null, e.target.value);
    }

    const onChangeSelectedOptions = (option: ISurveyQuestionOption, selected: boolean): boolean => {
        let selectedOptions = answers;
        if (selected) {
            if (question.chooseCount < 1 || question.chooseCount > answers.length) {
                selectedOptions = [...answers, {
                    optionSeq: option.optionSeq,
                    textAnswer: "",
                    isDirectInput: option.inputType === "02",
                }];
            } else if (question.chooseCount === 1) {
                selectedOptions = [{
                    optionSeq: option.optionSeq,
                    textAnswer: "",
                    isDirectInput: option.inputType === "02",
                }];
                setOptions(options.map(o => {
                    return {
                        ...o,
                        selected: o.optionSeq === option.optionSeq
                    }
                }));
            } else {
                addToast(`최대 ${question.chooseCount}개 선택할 수 있습니다.`);
                return false;
            }
        } else {
            selectedOptions = selectedOptions.filter(a => a.optionSeq !== option.optionSeq);
        }
        setAnswers(selectedOptions);
        
        if (onChangeAnswers) {
            onChangeAnswers(question, selectedOptions);
        }

        return true;
    }

    return (
        <S.Question>
            <Trg16 text={`${index + 1}. ${question.questionText} (${question.requiredYn === "Y" ? "필수" : "선택"})`}></Trg16>
            <Spacer size="xs"></Spacer>
            {question.questionType === "01" &&
                options.map(option => {
                    return (
                        <OptionButton
                            key={`q_o_${question.questionSeq}.${option.optionSeq}`}
                            option={option}
                            onClick={onChangeSelectedOptions} 
                            onChangeText={onChangeOptionText}
                        />
                    )
                })
            }
            {
                question.questionType === "02" &&
                <Textarea placeholder="내용을 입력해주세요." maxCount={400} onChange={onChange} state={'enabled'} text={text}></Textarea>
            }
        </S.Question>
    );
}

export default SurveyQuestion;
